<template>
    <div>
        <nav-bar></nav-bar>
        <div class="content">
            <nav-left-bar :active="0"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <div class="l">
                        <img src="../../assets/icon/bg.png" alt="" />
                        <div class="tc">{{order_info.name}}</div>
                    </div>
                </div>
                <div class="details">
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">{{order_info.name}}</div>
                    </div>
                    <div class="line"></div>
                    <div class="lk">
                        <img src="../../assets/icon/details_1.png" alt="" />
                        <div>实验室设备归属：{{device_info.section_name}}</div>
                    </div>
                    <div class="lk">
                        <img src="../../assets/icon/details_2.png" alt="" />
                        <div>实验室设备位置：{{device_info.address_lab_name_text}}</div>
                    </div>
                    <div class="lk">
                        <img src="../../assets/icon/details_3.png" alt="" />
                        <div>
                            实验室设备描述：{{device_info.content}}
                        </div>
                    </div>
                    <div class="lk">
                        <img src="../../assets/icon/details_1.png" alt="" />
                        <div>实验室设备管理员：{{device_info.manager_name}}</div>
                    </div>
                    <div style="height:29px"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">申请信息</div>
                    </div>
                    <div class="line"></div>
                    <div class="lk-input">
                        <label>设备名称：</label>
                        <input type="text" :value="order_info.name" disabled/>
                    </div>
                    <div class="lk-input">
                        <label>预约人：</label>
                        <input type="text" :value="order_info.user_name" disabled/>
                    </div>
                    <div class="lk-input">
                        <label>联系方式：</label>
                        <input type="text" :value="order_info.user_phone" />
                    </div>
                    <div class="lk-input">
                        <label>预约主题：</label>
                        <input
                            type="text"
                            :value="order_info.theme" disabled
                        />
                    </div>
                    <div class="lk-input speak">
                        <label>预约说明：</label>
                        <textarea :value="order_info.explain" disabled></textarea
                        >
                    </div>
                    <div style="height:40px"></div>

                    <div class="lk-input">
                        <label>使用时间：</label>
                        <input type="text" :value="order_info.start_time_text +'~'+order_info.end_time_text" disabled />
                    </div>

                    <div class="lk-input" v-if="type!=1">
                        <label>状态</label>
                        <input type="text" :value="type==2 ? '未通过':'已通过'" disabled />
                    </div>
                    <div style="height:50px"></div>
                    <div class="list-pass" v-if="type==1">
                        <div class="no" @click="noPass('no')">不通过</div>
                        <div class="pass" @click="pass('yes')">通过</div>
                    </div>

                    <div style="height:30px;"></div>
                </div>
            </div>
        </div>
        <van-dialog
            v-model="showNo"
            title="确认不通过"
            show-cancel-button
            width="430"
            confirmButtonColor="#DC3733" @confirm="adopt" @cancel="cancel"
        >
            <div class="titleno">确认该预约申请不通过？</div>
            <div class="lineno"></div>
            <textarea class="notextarea" placeholder="请填写原因～" v-model="reasons"></textarea>
        </van-dialog>
        <van-dialog
            v-model="showYes"
            title="确认通过"
            show-cancel-button
            width="430"
            confirmButtonColor="#DC3733" @confirm="adopt"
        >
            <div class="titleno">确认该预约申请通过？</div>
        </van-dialog>
    </div>
</template>
<script>
export default {
    name: "approvalDetails",
    data() {
        return {
            showNo: false,
            showYes: false,
            order_info:{},
            device_info:{},
            type:2,
            showStatus:'yes',
            reasons:''
        };
    },
    methods: {
        noPass(no) {
            this.showNo = true;
            this.showStatus=no
        },
        pass(yes) {
            this.showYes = true;
            this.showStatus=yes
        },
        cancel(){
            this.reasons=''
        },
        adopt(){
            let params={
                opmode:this.showStatus,
                reasons:this.reasons,
                order_id:this.$route.query.id
            }
             if(this.showStatus=='no' && this.reasons==''){
                this.$toast('请先填写原因')
                return
            }
            this.$post('/api/person/my_approval_operate',params).then(res=>{
                if(res.code==1){
                    this.$toast(res.msg)
                    setTimeout(() => {
                        this.$router.push('/approval')
                    }, 1500);
                }
            })
            .catch(err=>{
                console.log(err)
            })
        },
        details(){
           
            this.$post('/api/person/my_device_approval_info',{
                id:this.$route.query.id
            }).then(res=>{
                if(res.code==1){
                    res.data.order_info.end_time_text=res.data.order_info.end_time_text.substring(5,17)
                    this.order_info=res.data.order_info
                    this.device_info=res.data.device_info
                    this.type=this.$route.query.type
                }
            }).catch(err=>{
                console.log(err)
            })
        }
    },
    mounted(){
        this.details()
    }
};
</script>
<style lang="less" scoped>
.van-dialog {
    font-size: 24px !important;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    color: #1c2833;
}
.titleno {
    opacity: 0.7;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #999999;
    padding: 20px 0 17px 0;
}
.lineno {
    width: 100%;
    height: 3px;
    background: #f1f1f1;
}
.notextarea {
    width: 384px;
    height: 99px;
    background: #f7f7f7;
    margin: 11px 0 39px 0;
    padding: 8px 0 0 11px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    &::placeholder {
        color: #999999;
    }
}
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        // line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .l {
                display: flex;
                height: 100%;
                align-items: center;
                img {
                    width: 5px;
                    height: 24px;
                }
                .tc {
                    font-size: 24px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #333333;
                    padding-left: 13px;
                }
            }
        }
        .details {
            width: 838px;
            height: auto;
            background: #ffffff;
            margin-top: 21px;
            .title {
                display: flex;
                height: 43px;
                align-items: center;
                .ricle {
                    width: 4px;
                    height: 4px;
                    background: #ffffff;
                    border: 3px solid #3449d3;
                    border-radius: 50%;
                    margin-left: 20px;
                }
                .txt {
                    font-size: 18px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: left;
                    color: #333333;
                    padding-left: 14px;
                }
            }
            .line {
                width: 793px;
                border: 1px dashed #eaecfa;
                margin-left: 20px;
            }
            .list-pass {
                display: flex;
                height: 44px;
                align-items: center;
                .no {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #6480ec;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    margin-left: 20px;
                    cursor: pointer;
                }
                .pass {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #3449d3;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    margin-left: 50px;
                    cursor: pointer;
                }
            }
            .lk {
                display: flex;
                padding-left: 20px;
                padding-top: 20px;
                img {
                    // width: 18px;
                    height: 18px;
                }
                > div {
                    max-width: 745px;
                    font-size: 16px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #333333;
                    line-height: 20px;
                    padding-left: 14px;
                }
                .eq {
                    width: 290px !important;
                    height: 190px !important;
                    margin-left: 27px;
                    object-fit: cover;
                }
            }

            .lk-input {
                display: flex;
                height: 40px;
                align-items: center;
                padding-left: 45px;
                padding-top: 20px;
                label {
                    width: 77px;
                    font-size: 15px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #333333;
                    letter-spacing: 0px;
                }
                input {
                    width: 270px;
                    height: 40px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    margin-left: 16px;
                    padding-left: 10px;
                    font-size: 14px;
                    &::placeholder {
                        color: #999999;
                    }
                }
                textarea {
                    width: 332px;
                    height: 76px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    margin-left: 15px;
                    margin-top: 40px;
                    padding: 10px 0 0 8px;
                    font-size: 14px;
                }
            }

            .zhushi {
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #333333;
                padding: 27px 0 60px 40px;
            }
            .replay {
                display: flex;
                height: 44px;
                align-items: center;
                width: 100%;
                justify-content: center;
                padding-bottom: 60px;
                .left {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #3449d3;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    margin-right: 50px;
                    cursor: pointer;
                }
                .right {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #6480ec;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
        }
    }
}
.show {
    position: fixed;
    z-index: 11;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #333333;
    opacity: 0.5;
    width: 100%;
    height: 100%;
}
.close {
    width: 50px;
    height: 50px;
    position: fixed;
    left: 0;
    right: 0;
    z-index: 111;
    bottom: 100px;
    margin: 0 auto;
    cursor: pointer;
}
.ing {
    width: 590px;
    height: 466px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.19);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1000;
    .title {
        width: 100%;
        height: 81px;
        line-height: 81px;
        background: #f3f5fc;
        border-radius: 6px 6px 0px 0px;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
    }
    .list {
        width: 100%;
        height: 356px;
        overflow-y: scroll;
        // display: flex;
        flex-direction: column;
        align-items: center;
        display: -webkit-inline-box;
        .li {
            width: 510px;
            display: flex;
            height: 80px;
            align-items: center;
            border-bottom: 1px solid #f8f8f8;
            .time {
                font-size: 20px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                letter-spacing: 0px;
            }
            .con {
                font-size: 18px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 400;
                color: #333333;
                letter-spacing: 0px;
                padding-left: 30px;
            }
            img {
                width: 69px;
                height: 25px;
                margin-left: 30px;
            }
        }
    }
}
</style>
